import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router';
import { redirectToOnboardingIntroduction, redirectToOnboardingRingSolutionsEmergencyContacts, redirectToURL } from '$src/utils/redirect';
import { Skeleton } from 'antd';
import useStores from '$src/hooks/useStores';
import useLocationContext from '$src/hooks/useLocationContext';
import OnboardingContainer from '$src/components/OnboardingContainer';
import emergencyContactsImg from '$src/assets/img/onboardingEmergencyContacts.png';
import { MonitoringSettingsIcon } from '@ring-icons';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import { Cell } from '@amzn/ring-react-components/csr/components/Cell';

import './index.less';

function EmergencyContacts() {
  const {
    preferencesStore: { fetchContacts, contacts, loading },
    sessionStore: { user, isMobile },
  } = useStores();
  const { state } = useLocation();
  const locationId = useLocationContext();

  useEffect(() => {
    if (user.user_id && locationId) {
      fetchContacts(user.user_id, locationId);
    }
  }, [fetchContacts, user.user_id, locationId]);

  return (
    <OnboardingContainer
      headerTitle="Emergency Contacts"
      icon={MonitoringSettingsIcon}
      title="Review your Emergency Contacts."
      subtitle="Depending on your alert preferences, Virtual Guards will notify you and your Ring emergency contacts of events by text message and/or phone."
      primaryText="Continue"
      secondaryText="Edit"
      image={emergencyContactsImg}
      handleClose={() => (state?.handleClose ? redirectToURL(state?.handleClose) : handleBackToRingDashboard(isMobile))}
      handleBack={() => (state?.handleBack ? redirectToURL(state?.handleBack) : redirectToOnboardingIntroduction(locationId))}
      primaryActionHandler={() =>
        state?.primaryActionHandler ? redirectToURL(state?.primaryActionHandler) : redirectToOnboardingIntroduction(locationId)
      }
      secondaryActionHandler={() => redirectToOnboardingRingSolutionsEmergencyContacts(locationId)}
      warningOnClose
      data-testid="emergency-contacts"
      className="emergency-contacts"
    >
      <Skeleton active loading={loading}>
        {contacts.map((c) => (
          <Cell key={c.seqNum} title={<b>Emergency Contact #{c.seqNum}</b>}>
            {c.firstName} {c.lastName}
          </Cell>
        ))}
      </Skeleton>
    </OnboardingContainer>
  );
}

export default observer(EmergencyContacts);
